import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { ServiceLocations } from '../../shared/api-models/admin';
import { ClientHistoryNotes } from '../../shared/api-models/log';
import { LocationsService } from '../locations/locations.service';
import { HistoryNotesService } from './history-notes.service';

@Component({
	selector: 'app-history-notes',
	templateUrl: './history-notes.component.html',
	styleUrls: ['./history-notes.component.scss']
})
export class HistoryNotesComponent implements OnInit, OnDestroy {
	public searchResults: ClientHistoryNotes[] = [];
	public spinnerActive: boolean;

	private searchTermChanged: Subject<string> = new Subject<string>();
	private subs: Subscription[] = [];

	constructor(public historyNotesService: HistoryNotesService, public locationsService: LocationsService) {
		this.searchTermChanged.pipe(debounceTime(800)).subscribe((_) => {
			this.getHistoryNotes(this.serviceLocationId(this.historyNotesService.viewState.locationId), true);
		});
	}

	ngOnInit() {
		this.getHistoryNotes(null, false);
		if (!this.locationsService.locationsDropdownView) {
			this.locationsService.getAllLocationsForClient().subscribe((locations: ServiceLocations[]) => {
				this.locationsService.locationsDropdownView = locations;
				this.locationsService.locationsDropdownView.unshift({ Name: 'All' });
			});
		}
	}

	public getHistoryNotes(serviceLocationId: number, refreshData: boolean): void {
		this.spinnerActive = true;
		this.historyNotesService.getHistoryNotes(serviceLocationId, refreshData).subscribe((historyNotes: ClientHistoryNotes[]) => {
			this.historyNotesService.historyNotes = historyNotes;
			this.spinnerActive = false;
		});
	}

	onLocationSelect(location: ServiceLocations): void {
		this.historyNotesService.viewState.locationId = location.Id;
		this.getHistoryNotes(this.serviceLocationId(location.Id), true);
	}

	private serviceLocationId(id: number): number {
		return id !== -1 ? id : null;
	}

	public showSystemMessagesClick(): void {
		this.historyNotesService.viewState.includeSystemGenerated = !this.historyNotesService.viewState.includeSystemGenerated;
		this.historyNotesService.viewState.pageNumber = 1;
		if (this.historyNotesService.viewState.includeSystemGenerated) {
			this.getHistoryNotes(this.historyNotesService.viewState.locationId, true);
		} else {
			this.getHistoryNotes(this.historyNotesService.viewState.locationId, true);
		}
	}

	onSearchKeyup(searchTerm: string) {
		this.spinnerActive = true;
		this.historyNotesService.searchTerm = searchTerm;
		this.searchTermChanged.next(this.historyNotesService.searchTerm);
	}

	public onSearchClear(): void {
		this.historyNotesService.searchTerm = '';
		this.historyNotesService.viewState.pageNumber = 1;
		this.getHistoryNotes(this.serviceLocationId(this.historyNotesService.viewState.locationId), true);
	}

	ngOnDestroy() {
		this.subs.forEach((sub) => sub.unsubscribe());
	}
}
